// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

// @flow
import axios from 'axios'
import {APIUrl, APIHeaders} from './utils'
import {SMI_API} from '../config'
import {showSpinner} from './spinner'
import {errorToast} from './toastMessages'

export const GET_DEVICES = 'get_devices'
export const FETCH_DEVICES = 'fetch_devices'

export function fetchDevices () {
  // This function is fully mocked
  return (dispatch, getState) => {
    const {session} = getState()
    const url = APIUrl('devices', {}, SMI_API)
    dispatch(showSpinner(true))
    return axios.get(url, {headers: APIHeaders(session)}).then(data => {
      dispatch(showSpinner(false))
      dispatch({
        type: FETCH_DEVICES,
        payload: data.data
      })
    }).catch(() => {
      dispatch(showSpinner(false))
      dispatch(errorToast('Failed to get devices.'))
    })
  }
}
